export const toggleSidebar = () => dispatch => {
  dispatch({
    type: 'toggleSidebar',
  });
};

export const closeSidebar = () => dispatch => {
  dispatch({
    type: 'closeSidebar',
  });
};
